export const FILTER = {
  AREA: 'AREA',
  PROCESS: 'PROCESS',
  DATA: 'DATA',
  CATEGORY: 'CATEGORY',
  PROCESSING: 'PROCESSING',
  LEGAL_BASE: 'LEGAL_BASE',
  POSITION: 'POSITION',
};
